import { k1Axios } from './axios';
import { AccountFeatureFlag, PageableResponse } from '../models';
import { composeQuery, Query } from '../models/query';

export const getAccountFeatureFlags = async (...criteria: Query<AccountFeatureFlag>[]) => (await k1Axios.get<PageableResponse<AccountFeatureFlag>>('/account-feature-flag', {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  params: composeQuery<AccountFeatureFlag>(...criteria),
  data: {},
})).data;
